// removed by extract-text-webpack-plugin
module.exports = {"hiddenText":"OffscreenAriaLive__hiddenText___t7CRw"};